module.exports = __webpack_public_path__ + "img/icon-close-white.7f22b4ff.svg";